import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Row, Col } from 'antd';

class FormFilterString extends Component {
  _onValidate = (err, formValues) => {
    if (!err) {
      const formFilterString = {
        input: formValues.input,
      };
      this.props.onSubmit(
        this.props.type,
        formFilterString,
        this.props.flagPrefix,
      );
    }
  };

  onCancel = () => {
    this.props.cancelFunction(this.props.type, this.props.flagPrefix);
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderForm = () => {
    const { getFieldDecorator } = this.props.form;
    const { type } = this.props;
    const inputType = 'text';
    let valueFormatter = '';
    if (type === 'phone_number') {
      valueFormatter = e => e.target.value.replace(/[^\d+]/g, '');
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col className="tright">
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('input', {
                rules: [
                  {
                    required: true,
                    message: 'input required',
                  },
                ],
                getValueFromEvent: valueFormatter,
              })(
                <Input
                  type={inputType}
                  size="large"
                  ref={refs => {
                    refs.focus();
                  }}
                />,
              )}
            </Form.Item>
            <div className="row-submit">
              <Button className="btn cancel-btn" onClick={this.onCancel}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" className="btn">
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormFilterString.propTypes = {
  form: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  flagPrefix: PropTypes.string,
};

export default FormFilterString;
